import {Tooltip} from "@mantine/core";
import dayjs from "dayjs";
import {isEmpty} from "lodash";
import Link from "next/link";
import React from "react";

import classes from "./Review.module.scss";
import type {Review as ReviewType} from "../../graphql/types";
import StarRating from "../StarRating";

export interface ReviewProps {
  review: Partial<ReviewType>;
  forType?: string | null;
}

export default function Review({review, forType}: ReviewProps) {
  const reviewDate = dayjs(review.createdAt);

  const locationParts: Array<[string, React.ReactNode]> = []; // ["key", value]

  if (forType === "Park" && review.facility?.slug) {
    locationParts.push([
      "Campground:",
      <Link
        key={review.facility.slug}
        href={`/facilities/${review.facility.slug}`}>
        {review.facility.name}
      </Link>,
    ]);
  }

  if (forType !== "Unit" && review.unit?.slug) {
    if (review.unit.loopName) {
      locationParts.push(["Loop:", review.unit.loopName]);
    }

    locationParts.push([
      "Site:",
      <Link key={review.unit.slug} href={`/units/${review.unit.slug}`}>
        {review.unit.name}
      </Link>,
    ]);
  }

  return (
    <div className={classes.review}>
      <StarRating rating={review.rating || 0} maxRating={5} readOnly />
      <div className={classes.name}>{review.reviewerName}</div>
      {!isEmpty(locationParts) && (
        <div className={classes.location}>
          {locationParts.map(([key, value]) => (
            <div className={classes.locationItem} key={key}>
              <span className={classes.locationItemKey}>{key}</span>
              <span className={classes.locationItemValue}>{value}</span>
            </div>
          ))}
        </div>
      )}
      <div className={classes.createdAt}>
        Reviewed{" "}
        <Tooltip withArrow inline label={reviewDate.format("LLLL")}>
          <span>{reviewDate.fromNow()}</span>
        </Tooltip>
      </div>
      <div className={classes.comment}>{review.comment}</div>
    </div>
  );
}
